// import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { useAuth } from '../utils/Auth';
import { PilihRole } from '../pages/auth/PilihRole';
import { NavbarLms } from './NavbarLms';
// import { useEffect } from 'react';

const MasterLayout = () => {
  const location = useLocation();
  const { role } = useAuth();
  const {pathname} = location
  const arr_path = pathname.split('/')
  const path_lms = pathname.includes("lms")
  const course_learn_page = pathname.includes('/lms/course/') && arr_path[arr_path.length-1] === 'learn'
  const lms_dashboard = pathname.includes('/lms/dashboard')
  const path_ujian = pathname.includes("/ujian/") || course_learn_page

  // function useOutsideAlerter(location) {
  //   useEffect(() => {
  //     function ctrlShiftKey(e, key) {
  //       return e.ctrlKey && e.shiftKey && e.key === key;
  //     }
  //     function disableContextMenu(e) {
  //       return e.preventDefault()
  //     }
  //     function disableKeydown(e) {
  //       if (
  //         e.key === "F12" ||
  //         ctrlShiftKey(e, "KeyI") ||
  //         ctrlShiftKey(e, "KeyJ") ||
  //         (e.ctrlKey && e.key === "u")
  //       ) return e.preventDefault();
  //       else return e;
  //     }
  //     if (location.pathname.includes('/lms/course/') && location.pathname.includes('/learn') && role?.nama !== "Admin Iknow") {
  //     // if (location.pathname === '/dashboard') {
  //       document.addEventListener("contextmenu", disableContextMenu);
  //       document.addEventListener("keydown", disableKeydown);
  //     }
  //     else {
  //       document.removeEventListener("contextmenu", disableContextMenu);
  //       document.removeEventListener("keydown", disableKeydown);
  //     }
  //     // console.log(location.pathname)
  //     return () => { 
  //       // Unbind the event listener on clean up
  //       document.removeEventListener("contextmenu", disableContextMenu);
  //       document.removeEventListener("keydown", disableKeydown);
  //     };
  //   }, [location]);
  // }

  // useOutsideAlerter(location);

  return (
    <div>
      {!role.selected ?
          <PilihRole /> :
          <>
            {!(path_ujian || lms_dashboard) && (
              path_lms ?
                <NavbarLms /> :
                <Navbar />
            )}
            <div className={path_lms ? 'bodyContentLms' : 'bodyContent'}>
              <Outlet />
            </div>
          </>
      }
    </div>
  );
}

export default MasterLayout;
